import { useEffect, useState } from 'react';

import { obterAssinatura, obterResumoDoPlano, STATUS_ASSINATURA } from 'services/assinaturaService';

/** Status que deixam o cadastro do profissional irregular e exigem ação dele. */
const STATUS_COM_PENDENCIA = [
  STATUS_ASSINATURA.PENDENTE,
  STATUS_ASSINATURA.INADIMPLENTE,
  STATUS_ASSINATURA.SUSPENSA,
];

/**
 * Indica se a assinatura do usuário logado está irregular — a definição de "pendência no
 * cadastro" fica aqui para o aviso do dashboard e o selo do menu nunca discordarem.
 *
 * Falha de rede é engolida de propósito: quem consome isso é sinalização acessória e não
 * pode derrubar a tela em que está.
 *
 * @param {boolean} habilitado — passe false para cliente, que não tem assinatura a regularizar.
 */
export function usePendenciaAssinatura(habilitado = true) {
  const [temPendencia, setTemPendencia] = useState(false);

  useEffect(() => {
    if (!habilitado) {
      setTemPendencia(false);
      return undefined;
    }

    let ativo = true;
    // C8: quem diz se há pendência é o backend (resumo.pendencia), o mesmo que alimenta o card "Meu
    // plano" e a Assinatura -- assim a pendente do Pro grátis de Fundador(a), que só vence no fim dele,
    // não acende o selo. Sem resumo (backend anterior, falha), cai na regra antiga, pelo status.
    Promise.resolve()
      .then(() => obterResumoDoPlano())
      .then((resumo) => {
        if (resumo && typeof resumo.pendencia === 'boolean') return resumo.pendencia;
        return obterAssinatura().then((assinatura) => !!assinatura && STATUS_COM_PENDENCIA.includes(assinatura.status));
      })
      .catch(() => obterAssinatura()
        .then((assinatura) => !!assinatura && STATUS_COM_PENDENCIA.includes(assinatura.status)))
      .then((pendencia) => { if (ativo) setTemPendencia(Boolean(pendencia)); })
      .catch(() => { /* silencioso: sinalização acessória não pode atrapalhar a tela */ });

    return () => { ativo = false; };
  }, [habilitado]);

  return temPendencia;
}
